import { render, staticRenderFns } from "./EditCampaign.vue?vue&type=template&id=b2368c72&scoped=true&"
import script from "./EditCampaign.vue?vue&type=script&lang=js&"
export * from "./EditCampaign.vue?vue&type=script&lang=js&"
import style0 from "./EditCampaign.vue?vue&type=style&index=0&id=b2368c72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2368c72",
  null
  
)

export default component.exports